export default __webpack_public_path__ + "static/media/deepfake.180b3479.jpeg";